module.exports = __webpack_public_path__ + "img/fa-brands-400.3237e6d6.svg";